// External libraries
import gql from 'graphql-tag';

export const CARD_META_QUERY = gql`
  query CardMetaQuery(
    $cardNumber: String!
    $countryCode: CountryCodes
    $shouldGetCardCobrand: Boolean!
    $shouldGetCardDefinitions: Boolean!
  ) {
    cardMeta(cardNumber: $cardNumber, countryCode: $countryCode) {
      definitions @include(if: $shouldGetCardDefinitions) {
        brand
        classifications
        confirmationMethods
        countryCode
      }
      cobrand @include(if: $shouldGetCardCobrand)
    }
  }
`;
